<span>
  <button mat-menu-item>
    @if (item.icon) {
      <mat-icon svgIcon="{{item.type}}" id="{{item.type}}"></mat-icon>
    }
    <p class="child-info">
      <a class="label accesible-link pt-2 pt-lg-0"  (click)="onNavigationClick(item)">
        {{item.label}}
        <div class="d-flex d-flex-column">
          @if (item.portfolio) {
            <span class="portfolio">
              {{item.portfolio}}
            </span>
          }
          @if (item.organization) {
            <span class="portfolio">
              {{item.organization}}
            </span>
          }
        </div>

      </a>

    </p>

  </button>
</span>
